import { FiltersContextState } from './filters.type'

export const InitialFilterState: FiltersContextState = {
  marketSegmentFilter: {
    fieldOperationsHubs: null,
    fieldOperationsRegions: null,
    marketSegmentIds: null,
    marketSegmentTypes: null,
  },
  reservationsFilters: {
    autopilot: false,
    moveInToday: false,
    moveIn48Hrs: false,
    moveIn3days: false,
    moveIn7Days: false,
    currentReservations: false,
    flightxInProgress: false,
    lexit: false,
    approved: true,
    pending: false,
  },
  propertiesFilters: {
    new: false,
    blocked: false,
  },
  homeQualityChecksFilters: {
    homeQualityCheckStatus: null,
  },
  homesFilters: {
    autopilot: false,
    blocked: false,
    vacant: false,
    newOD: false,
    direct: false,
    occupied: false,
    standard: false,
    published: false,
    installed: false,
    leased: false,
    scheduledForDeinstall: false,
  },
  jobsFilters: {
    claimed: false,
    unclaimed: false,
    completed: false,
    cancelled: false,
    future: false,
    next7Days: false,
  },
  notificationsFilters: {
    status: null,
  },
  scheduledCommunicationsFilters: {
    scheduledDatetime: null,
    scheduledCommunicationStatuses: null,
  },
  searchString: null,
  reservationMoveInRange: {
    moveInDate: undefined,
    moveInMax: undefined,
  },
  reservationMoveOutRange: {
    moveOutDate: undefined,
    moveOutMax: undefined,
  },
  reservationMinLengthOfStay: undefined,
}

export const currentSupportFiltersKey = 'active-support-filters'
